export default __webpack_public_path__ + "static/media/v-bt-r.2195a421.png";